import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import PropTypes from 'prop-types';

import FocusableHeader from 'components/focusableheader/FocusableHeader';
import { AppRoutes } from 'routes';

import Link from '../../components/link/Link';
import LoginForm from '../../components/loginForm/LoginForm';

const LoginPage = (props) => {
    const { formatMessage } = useIntl();
    return (
        <div className="login-page-content pprlpay-page-wrapper grey-banner">
            <FocusableHeader id="login-title">
                <FormattedMessage id="pages.login.title" />
            </FocusableHeader>
            <hr aria-hidden className="fs-bar orange" />
            <h2 id="login-subtitle">
                <FormattedMessage id="pages.login.subtitle" />
            </h2>

            <div className="wrapper-message pprlpay-page-primary-content">
                <div>
                    <div className="wrapper-button-sto-container">
                        <LoginForm
                            password={props.password}
                            setFormField={props.setFormField}
                            username={props.username}
                        />

                        <div className="pprlpay-link-container">
                            <Link
                                aria-label={formatMessage({ id: 'pages.login.forgotlogin' })}
                                id="page-login-button-forgotLogin"
                                to={AppRoutes.forgotCredentialsPage}
                            >
                                <FormattedMessage id="pages.login.forgotlogin" />
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
            <div className="pprlpay-page-secondary-content">
                <div className="pprlpay-link-container">
                    <p className="registrationlink-text">
                        <FormattedMessage id="pages.login.registrationtext" />
                    </p>
                    <Link
                        aria-label={formatMessage({ id: 'pages.login.registrationlink' })}
                        id="page-login-button-registerHere"
                        to={AppRoutes.registrationPage}
                    >
                        <FormattedMessage id="pages.login.registrationlink" />
                    </Link>
                </div>
            </div>
        </div>
    );
};

LoginPage.propTypes = {
    password: PropTypes.exact({
        errorMessage: PropTypes.string,
        isValid: PropTypes.bool,
        value: PropTypes.string.isRequired,
    }).isRequired,
    setFormField: PropTypes.func.isRequired,
    username: PropTypes.exact({
        errorMessage: PropTypes.string,
        isValid: PropTypes.bool,
        value: PropTypes.string.isRequired,
    }).isRequired,
};

export default LoginPage;
